import ReactDOM from 'react-dom';
import {BrowserRouter} from './routes';

ReactDOM.render(<BrowserRouter/>,document.getElementById('root'));